import React from "react";
import Form, { FormItemProps } from "antd/es/form";
import Select from "antd/es/select";
import { LocalizedSelectOption } from "pages/Survey/utils";

interface SelectFieldProps {
  options: LocalizedSelectOption[];
  multiple?: boolean;
  placeholder?: string;
  validationMessage?: string;
}

const SelectField: React.FC<FormItemProps & SelectFieldProps> = ({
  name,
  label,
  options,
  multiple,
  placeholder = "Оберіть відповідь",
  preserve,
  required,
  validationMessage = "Заповніть це поле",
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      preserve={preserve}
      rules={[{ required, message: validationMessage }]}
    >
      <Select
        allowClear
        mode={multiple ? "multiple" : undefined}
        optionFilterProp="children"
        placeholder={placeholder}
        showSearch
      >
        {options.map((item, index) => (
          <Select.Option key={`${item.value}-${index}`} value={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default SelectField;
